<template>
  <div class="app-content-wrapper">
    <div class="quick-filter">
      <div class="quick-filter-item" :class="quickFilterCode === item.code ? 'active' : ''" v-for="item in quickFilterOptions" :key="item.name" @click="handleQuickFilter(item.code)">
        <div class="quick-filter-item-text">{{ item.name }}</div>
      </div>
    </div>
    <div class="search-wrapper">
      <search-component ref="search"
                        class="refuse-search"
                        :search-condition="searchCondition"
                        :search-buttons="searchButtonList"
                        :fuzzySearchPlaceholder="fuzzySearchPlaceholder"
                        :showMerchantSearch="true"
                        date-picker-format="yyyy-MM-dd"
                        router-name="/transaction/refuse">

      </search-component>
    </div>
    <div class="table-wrapper">
      <custom-table :table-set="tableCondition"
                    :service-function="getChargebackList"
                    :is-first-automatic-visit="false"
                    :showMerchantNo="true"
                    ref="table"
                    router-name="/transaction/refuse">
      </custom-table>
    </div>
    <custom-message ref="customMessage"></custom-message>

    <!-- klarna 专属抗辩 -->
    <klarna-rebut-drawer
      ref="klarnaRebutDrawerRef"
      style="height: 100vh;"
      @success="initMethod"
    ></klarna-rebut-drawer>
  </div>
</template>
<script>
import { getQueryCardTypes } from '@/api/common';
import CustomMessage from '@/components/modal/message-box/custom-message.vue';
import { ShowSuccessMessage } from '@/components/modal/tips/message-tips';
import CustomTable from '@/components/table/custom-table.vue';
import SearchComponent from '@/components/table/search-component.vue';
import GlobalData from '@/utils/global/index';
import { getEnantiomericValue, initSelectedData, splicingAmountAndCurrency } from '@/utils/tools/constant';
import { getTodayParams } from '@/utils/tools/time';
import AppealService from '@/views/transaction/api/appeal-manage.service';
import KlarnaRebutDrawer from '@/views/transaction/refuse-manage/klarna-rebut/index.vue';

export default {
  components: {
    SearchComponent,
    CustomTable,
    CustomMessage,
    KlarnaRebutDrawer,
  },
  data() {
    return {
      getTodayParams,
      ...AppealService,
      downloading: false,
      chargebackStatusList: [],
      fuzzySearchPlaceholder: `${this.$t('message.tableCommon.txnSerialNumber')};${this.$t('message.tableCommon.originalTxnSerialNumber')};${this.$t('message.tableCommon.merchantOrderNumber')}`,
      searchCondition: [
        {
          key: ['chargebackDateStart', 'chargebackDateEnd'],
          name: 'message.refuse.date',
          type: 'date_time',
          dateType: 'date',
          dateFormat: 'yyyy-MM-dd',
          dateValueFormat: 'yyyy-MM-dd',
        },
        // {
        //   key: 'txnId',
        //   name: 'message.tableCommon.txnSerialNumber',
        //   type: 'input',
        //   defValue: '',
        // },
        // {
        //   key: 'originTxnId',
        //   name: 'message.tableCommon.originalTxnSerialNumber',
        //   type: 'input',
        //   defValue: '',
        // },
        // {
        //   key: 'externalOrderId',
        //   name: 'message.tableCommon.merchantOrderNumber',
        //   type: 'input',
        //   defValue: '',
        // },
        {
          key: 'chargebackArn',
          name: 'message.refuse.arn',
          type: 'input',
          defValue: '',
        },
        {
          key: 'chargebackStatus',
          name: 'message.refuse.status',
          type: 'select',
          defValue: [''],
          options: [],
          multiple: true,
          changeValue: (value) => {
            let list = [];
            if ((value[value.length - 1] === '')) {
              list = [''];
            } else {
              list = value.filter(item => item !== '');
            }

            this.currQuickFilter = list?.join(',') || '';
            this.$refs.search.setInputValue('chargebackStatus', list);
          },
        },
        {
          key: 'website',
          name: 'message.tableCommon.appWebsite',
          type: 'input',
          defValue: '',
        },
        {
          key: 'daysLeftToResponse',
          name: 'message.refuse.appealCountdown',
          type: 'select',
          defValue: '',
        },
        {
          key: 'cardType',
          name: 'message.tableCommon.cardType',
          type: 'select',
          defValue: '',
          options: [],
        },
      ],
      searchButtonList: [
        {
          type: 'download',
          permissionCode: 'transaction:refuse:download',
          func: async (param) => {
            if (!this.downloading) {
              this.downloading = true;
              try {
                await AppealService.downloadChargeback(param);
                ShowSuccessMessage(this.$t('message.common.downloadTask'));
              } catch (err) {
                //
              }
              this.downloading = false;
            }
          },
        },
      ],
      tableCondition: [
        {
          titleBar: { type: 'text', title: 'message.refuse.refuseId', filterKey: 'txnId' },
          key: 'id',
          type: 'click',
          subTableDisplays: [
            {
              type: 'link',
              key: 'id',
              router: '/transaction/refuse/details',
              valueKey: ['id'],
              paramsKey: ['id'],
            },
          ],
          itemWidth: 250,
        },
        {
          titleBar: { type: 'text', title: 'message.tableCommon.originalTxnSerialNumber_new', filterKey: 'originTxnId' },
          key: 'originTxnId',
          type: 'click',
          subTableDisplays: [
            {
              type: 'link',
              key: 'originTxnId',
              router: '/transaction/details',
              valueKey: ['originTxnId'],
              paramsKey: ['id'],
            },
          ],
          itemWidth: 250,
        },
        {
          titleBar: { type: 'text', title: 'message.refuse.date' },
          key: 'chargebackDate',
          type: 'text',
        },
        {
          titleBar: { type: 'text', title: 'message.settlement.refuseAmount' },
          key: 'chargebackCurrencyAndAmount',
          type: 'text',
          itemStyle: () => {
            return 'font-family: Avenir-Heavy, Avenir;font-weight: 800;line-height: 28px;';
          },
          textFunc: (data) => splicingAmountAndCurrency(data.chargebackCurrency, data.chargebackAmount),
        },
        {
          titleBar: { type: 'text', title: 'message.refuse.reason' },
          key: 'chargebackReason',
          type: 'text',
          itemStyle: () => {
            return 'font-family: Avenir-Heavy, Avenir;font-weight: 800;line-height: 28px;';
          },
        },
        {
          titleBar: { type: 'text', title: 'message.refuse.status', filterKey: 'chargebackStatus' },
          key: 'chargebackStatus',
          type: 'text',
          textFunc: (row) => getEnantiomericValue(this.chargebackStatusList, row.chargebackStatus),
          itemStyle: (data) => {
            if (data.chargebackStatus === 'ACCEPT' || data.chargebackStatus === 'SAS' || data.chargebackStatus === 'FAS') {
              return 'background:rgba(0,221,40,0.15);padding:2px 8px;border-radius:4px;';
            } else if (data.chargebackStatus === 'FAF' || data.chargebackStatus === 'FAT' || data.chargebackStatus === 'SAF' || data.chargebackStatus === 'SAT') {
              return 'background:rgba(252,100,45,0.15);padding:2px 8px;border-radius:4px;';
            } else if (data.chargebackStatus === 'REVOKE') {
              return 'background:#F1F5F7;padding:2px 8px;border-radius:4px;';
            }
            return 'background:rgba(255,178,9,0.15);padding:2px 8px;border-radius:4px;';
          },
        },
        {
          titleBar: { type: 'text', title: 'message.refuse.appealCountdown' },
          key: 'countdownTime',
          type: 'text',
          textFunc: (data) => {
            return this.getCountdownTime(data.countdownTime);
          },
          itemStyle: () => {
            return 'font-family: Avenir-Heavy, Avenir;font-weight: 800;line-height: 28px;';
          },
        },
        {
          titleBar: { type: 'text', title: 'message.refuse.enterTime' },
          key: 'importDate',
          type: 'text',
          isItemSettingsDisplay: false,
        },
        {
          titleBar: { type: 'text', title: 'message.tableCommon.merchantOrderNumber', filterKey: 'externalOrderId' },
          key: 'externalOrderId',
          type: 'text',
          isItemSettingsDisplay: false,
        },
        {
          titleBar: { type: 'text', title: 'message.tableCommon.appWebsite' },
          key: 'website',
          type: 'text',
          isItemSettingsDisplay: false,
        },
        {
          titleBar: { type: 'text', title: 'message.tableCommon.originTxnAmount' },
          key: 'txnCurrencyAndAmount',
          type: 'text',
          isItemSettingsDisplay: false,
        },
        {
          titleBar: { type: 'text', title: 'message.tableCommon.originTxnTime' },
          key: 'txnDate',
          type: 'text',
          isItemSettingsDisplay: false,
        },
        {
          titleBar: { type: 'text', title: 'message.tableCommon.cardType' },
          key: 'cardType',
          type: 'text',
        },
        {
          titleBar: { type: 'text', title: 'message.refuse.arn', filterKey: 'chargebackArn' },
          key: 'chargebackArn',
          type: 'text',
          isItemSettingsDisplay: false,
        },
        {
          titleBar: { type: 'text', title: 'message.refuse.code' },
          key: 'chargebackCode',
          type: 'text',
          isItemSettingsDisplay: false,
        },
        {
          titleBar: { type: 'text', title: 'message.refuse.submitMaterialsEndTime' },
          key: 'appealDueDate',
          type: 'text',
          isItemSettingsDisplay: false,
          textFunc: (data) => {
            return data.appealDueDate;
          },
        },
        {
          key: 'buttons',
          titleBar: { title: 'message.tableCommon.operation', type: 'operations' },
          type: 'operations',
          subTableDisplays: [
            {
              type: 'text_button',
              textFunc: () => 'message.tableCommon.details',
              permissionCode: 'transaction:refuse:details',
              func: (data) => {
                this.$router.push({ path: '/transaction/refuse/details', query: { id: data.id } });
              },
            },
            {
              type: 'text_button',
              textFunc: () => 'message.tableCommon.appeal',
              permissionCode: 'transaction:refuse:appeal',
              isDisplayFunc: (data) => data.chargebackStatus && (data.chargebackStatus === 'FAF' || data.chargebackStatus === 'NEW'),
              func: (data) => {
                if (data.chargebackStatus === 'FAF') {
                  this.$refs.customMessage.openHttpModal({
                    titleHtml: this.$t('message.refuse.secondAppealConfirm'),
                    contentHtml: this.$t('message.refuse.secondAppealConfirmTips'),
                    confirmFuntion: () => {
                      // this.$router.push({ path: '/transaction/refuse/appeal', query: { id: data.id } });
                      if (data.cardType === 'Klarna') {
                        this.$refs.klarnaRebutDrawerRef.open(data.id, false);
                      } else {
                        this.$router.push({ path: '/transaction/refuse/appeal', query: { id: data.id } });
                      }
                    },
                  });
                } else {
                  if (data.cardType === 'Klarna') {
                    this.$refs.klarnaRebutDrawerRef.open(data.id, false);
                  } else {
                    this.$router.push({ path: '/transaction/refuse/appeal', query: { id: data.id } });
                  }
                }
              },
            },
            {
              type: 'text_button',
              textFunc: () => 'message.tableCommon.acceptDishonor',
              permissionCode: 'transaction:refuse:acceptDishonor',
              isDisplayFunc: (data) => data.chargebackStatus && (data.chargebackStatus === 'FAF' || data.chargebackStatus === 'NEW'),
              func: (data) => {
                this.$refs.customMessage.openHttpModal({
                  titleHtml: this.$t('message.common.prompt'),
                  contentHtml: this.$t('message.refuse.refuseAcceptTips'),
                  httpFunction: this.postAcceptAppeal,
                  params: { id: data.id },
                  successFunction: this.onRefreshTable,
                });
              },
            },
            {
              type: 'text_button',
              textFunc: () => 'message.refuse.viewRebuttal',
              permissionCode: 'transaction:refuse:view',
              isDisplayFunc: (data) => data.chargebackStatus && (data.chargebackStatus !== 'NEW' && data.chargebackStatus !== 'FAF'),
              func: (data) => {
                if (data.cardType === 'Klarna') {
                  // 预览Klarna抗辩，需要禁用
                  this.$refs.klarnaRebutDrawerRef.open(data.id, true);
                } else {
                  this.$router.push({ path: '/transaction/refuse/view', query: { id: data.id } });
                }
              },
            },
          ],
        },
      ],
      // 快速筛选框
      quickFilterOptions: [
        {
          code: 'received',
          name: this.$t('message.refuse.quickFilterReceived'),
          value: ['NEW'],
        },
        {
          code: 'rebuttal',
          name: this.$t('message.refuse.quickFilterRebuttal'),
          value: ['FA', 'SA'],
        },
        {
          code: 'all',
          name: this.$t('message.refuse.quickFilterAll'),
          value: [''],
        },
        {
          code: 'won',
          name: this.$t('message.refuse.quickFilterWon'),
          value: ['FAS:SAS'],
        },
        {
          code: 'loss',
          name: this.$t('message.refuse.quickFilterLoss'),
          value: ['FAF', 'SAF'],
        },
        {
          code: 'close',
          name: this.$t('message.refuse.quickFilterClosed'),
          value: ['ACCEPT', 'REVOKE', 'FAT', 'SAT'],
        },
      ],
      // 快速筛选框当前 选中
      currQuickFilter: '',
    };
  },
  methods: {
    async initMethod() {
      await GlobalData.getDictList(['CHARGEBACK_STATUS', 'DISPUTE_DAYS_LEFT']).then((res) => {
        this.chargebackStatusList = initSelectedData(res.CHARGEBACK_STATUS);
        const statusList = this.chargebackStatusList.filter(item => (item.value !== 'SAS'));

        this.$refs.search.setSearchSelectOptions('chargebackStatus', statusList);
        this.$refs.search.setSearchSelectOptions('daysLeftToResponse', initSelectedData(res.DISPUTE_DAYS_LEFT));
      }).catch(() => {
      });
      this.$refs.table.firstVisitHttp();
      this.initCardTypes();
      this.initQuickFilter();
    },
    /**
     * 根据路由 初始化快速筛选框判断值
     */
    initQuickFilter() {
      this.currQuickFilter = this.$route.query.chargebackStatus;
    },
    /**
     * 初始化卡种
     */
    initCardTypes() {
      getQueryCardTypes('').then((data) => {
        if (this.$refs.search) {
          this.$refs.search.setSearchSelectOptions('cardType', initSelectedData(data, ''));
        }
      }).catch(() => ({}));
    },
    /**
     * 刷新当前表单
     */
    onRefreshTable() {
      this.$refs.table.refreshTable();
    },
    /**
     * 刷新当前表单
     */
    getCountdownTime(countdownTime) {
      if (countdownTime > 0) {
        const days = Math.floor(countdownTime / (1000 * 60 * 60 * 24)); // 计算天数
        if (days >= 1) {
          return this.$t('message.subscription.frequencyData.D', { day: days });
        } else {
          const hours = Math.floor(countdownTime / (1000 * 60 * 60) % 24); // 计算小时数
          const surplusHours = countdownTime / (1000 * 60 * 60) % 24 - hours;
          const minutes = Math.floor(surplusHours * 60); // 计算分钟数
          return this.$t('message.subscription.frequencyData.H', { hour: hours }) + ' ' +
            this.$t('message.subscription.frequencyData.M', { minute: minutes });
        }
      } else if (countdownTime === null) {
        return '--';
      } else {
        return this.$t('message.refuse.expired');
      }
    },
    // 选中快速筛选事件
    handleQuickFilter(code) {
      const selectValues = this.quickFilterOptions.find(item => item.code === code).value;
      // 避免重复请求
      if (this.currQuickFilter === selectValues?.join(',')) {
        return;
      }
      this.$refs.search.resetForm(); // 重置查询条件
      this.currQuickFilter = selectValues?.join(',') || '';
      this.$refs.search.setInputValue('chargebackStatus', selectValues);
      this.$refs.search.onSearch();
    },
    judgeQuickFilter() {
      if (!this.currQuickFilter) {
        return 'all';
      }
      const quickFilterArr = this.currQuickFilter.split(',');
      const selectedOption = this.quickFilterOptions.find((item) => item.value.sort().join(',') === quickFilterArr.sort().join(','));
      return selectedOption ? selectedOption.code : '';
    },
  },
  computed: {
    quickFilterCode() {
      return this.judgeQuickFilter();
    },
  },
  mounted() {
    this.initMethod();
  },
};
</script>
<style lang="scss" scoped>
@import '@/styles/variables.scss';
#refundDetail .is-bordered-label {
  width: 50%;
}
// html[lang=en] .refuse-search .fuzzy-input-box {
//   width: 536px !important;
// }

.quick-filter {
  display: flex;
  align-items: center;
  justify-content: space-around;

  background: #FBFBFD;
  border-radius: 8px 8px 8px 8px;
  padding: 16px;
  gap: 10px;

  .active {
    box-shadow: 0px 0px 0px 2px #F1F1FF !important;
    border: 1px solid $color-primary !important;
  }

  .quick-filter-item {
    flex: 1;
    height: 48px;
    line-height: 48px;
    background: #FFFFFF;
    border-radius: 8px 8px 8px 8px;
    border: 1px solid #D0D5DD;
    padding-left: 16px;
    cursor: pointer;
    .quick-filter-item-text {
      font-family: Open Sans, Open Sans;
      font-weight: 400;
      font-size: 14px;
      color: #667085;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }
  }

}

</style>
